import React, { useState, useContext, useMemo } from 'react';
import './style.css';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import { ProjectsPayoffContext } from '../../YourOptions';

const ListView = ({ projects, climate_risks, handleProjectClick, handleUserRemovingSimulatorProjectId, simulatorView = false }) => {
    const { userSelectedSimulatorProjectIds } = useContext(ProjectsPayoffContext);

    const [showAllProjects, setShowAllProjects] = useState(true);
    // Create unique house areas from projects
    const houseAreas = useMemo(() => {
        const uniqueAreas = new Map();

        // Add ALL option first
        uniqueAreas.set('all', {
            project_home_category_id: 'all',
            project_home_category: 'All Areas',
            house_category_icon: 'Home-Black.png' // You might want to adjust this icon
        });

        // Add other areas
        projects.forEach(project => {
            const id = project.project_home_category_id;
            if (!uniqueAreas.has(id)) {
                uniqueAreas.set(id, {
                    project_home_category_id: id,
                    project_home_category: project.project_home_category,
                    house_category_icon: project.house_category_icon
                });
            }
        });

        // Convert to array and sort alphabetically by category name, keeping 'All Areas' first
        return Array.from(uniqueAreas.values()).sort((a, b) => {
            if (a.project_home_category === 'All Areas') return -1;
            if (b.project_home_category === 'All Areas') return 1;
            return a.project_home_category.localeCompare(b.project_home_category);
        });
    }, [projects]);

    // Add state for selected filter
    const [selectedFilter, setSelectedFilter] = useState('all');

    // Filter and sort projects based on selection
    const filteredProjects = useMemo(() => {
        let filtered = selectedFilter === 'all'
            ? projects
            : projects.filter(project => project.project_home_category_id === selectedFilter);

        // Sort by project_total_payback in descending order
        return filtered.sort((a, b) => b.project_total_payback - a.project_total_payback);
    }, [projects, selectedFilter]);

    // const handleProjectClick = (project) => {
    //     setSelectedProject(project);
    //     if (showAllProjects) {
    //         setShowAllProjects(false);
    //     }
    // }

    return (
        <>
            <div className="list-view__container">
                <div className="review-all-projects__all-projects-container">
                    <div className="review-all-projects__filter-section">
                        <span className='review-all-projects__filter-section-label'>Filter by:</span>
                        <div className="review-all-projects__filter-bar">
                            {houseAreas.map(area => (
                                <button
                                    key={area.project_home_category_id}
                                    className={`review-all-projects__filter-button ${selectedFilter === area.project_home_category_id ? 'active' : ''}`}
                                    onClick={() => setSelectedFilter(area.project_home_category_id)}
                                >
                                    {area.project_home_category}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className='review-all-projects__all-projects-list'>
                        {filteredProjects.map((project) => (
                            <ProjectsListCard
                                key={project.project_id}
                                project={project}
                                handleProjectClick={() => handleProjectClick(project.project_id)}
                                isSelected={true}
                                showAllDetails={true}
                                simulatorView={true}
                                handleAddingProjectToSimulator={() => handleUserAddingSimulatorProjectId(project.project_id)}
                                handleRemovingProjectFromSimulator={() => handleUserRemovingSimulatorProjectId(project.project_id)}
                                allowDragging={true}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>

    );
};

export default ListView;
